import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import SystemLoad from './SystemLoad';
import AnalystDetails from './AnalystDetails';

import RangedDtPicker from '../../../components/RangedDtPicker';

import moment from 'moment';

import style from './index.scss';

import { getSupervisorDashboardData } from '../../../redux/actions/ns/supervisorDashboard';

class SupervisorDashboard extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {
      dateRange: {
        startDate: moment().subtract(1, 'months'),
        endDate: moment(),
        activeRangeNo: 2
      }
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getSupervisorDashboardData());
  }

  render() {
    const { dateRange } = this.state;
    const { supervisorDashboard } = this.props;
    const data = supervisorDashboard.data;
    if (data) {
      return (
        <div className={style.wrapper}>
          <div className={classnames('row', style.topFilter)}>
            <div className={classnames('col-md-12')}>
              <RangedDtPicker
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                activeRangeNo={dateRange.activeRangeNo}
                onDateChange={() => {}}
              />
            </div>
          </div>

          <SystemLoad data={data.system_load_data} />

          <AnalystDetails data={data.analyst_details_data} />
        </div>
      );
    }

    return null;
  }
}

function mapStateToProps(state, ownProps = {}) {
  return {
    supervisorDashboard: state.nsSupervisorDashboard
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupervisorDashboard);
